import {createAsyncAction} from "./utils";

export const login = createAsyncAction('AUTH/LOGIN');

export const logout = (error = null) => ({
    type: 'AUTH/LOGOUT',
    error,
});
